import { Controller } from "@hotwired/stimulus"
import iframeResize from "iframe-resizer/js/iframeResizer"

// Parent half of iframe-resizer: auto-sizes the embedded Drupal (app-view /
// chrome-less) iframe to its content height so there's no inner scrollbar. The
// child half (iframeResizer.contentWindow) is served by the Drupal theme on
// app-view pages. Attach via data-controller="iframe-resizer" on the <iframe>.
export default class extends Controller {
  connect() {
    iframeResize({
      // checkOrigin: false — the frame is cross-subdomain (app. <-> dev.jillianmichaels.com).
      checkOrigin: false,
      // Default bodyOffset (body.offsetHeight). The Drupal theme's app-view.css (loaded
      // only on chrome-less pages) removes the site-wide html/body height:100% +
      // .page-wrap min-height:100% that otherwise bind the page to the iframe viewport,
      // so the body sizes to its real content — bodyOffset then measures accurately and
      // grows/shrinks correctly per page (no white space, no clipped pager).
      heightCalculationMethod: "bodyOffset",
      log: false,
    }, this.element)
  }

  disconnect() {
    // Tear down on Turbo navigation so we don't leak listeners.
    if (this.element.iFrameResizer) {
      this.element.iFrameResizer.close()
    }
  }
}
